import { FontAwesomeIcon as FA } from '@fortawesome/react-fontawesome';
import React from 'react';
import { SortableContainer, SortableElement, SortableHandle, SortEnd } from 'react-sortable-hoc';
import arrayMove from 'array-move';
import TableSchema from '../models/TableSchema';

const DragHandle = SortableHandle(() => (
  <div>
    <FA className="ml-3" icon="grip-lines" />
  </div>
));

const SortableItem = SortableElement(
  ({
    tableSchema,
    column,
    isVisible,
    onCheckChanged,
  }: {
    tableSchema: TableSchema;
    column: string;
    isVisible: boolean;
    onCheckChanged(item: string, isChecked: boolean): void;
  }) => (
    <li
      className="list-group-item px-2 py-1 d-flex flex-row"
      // must be bigger than Bootstrap's dropdown
      // menu z-index (which is 1000)
      style={{ zIndex: 1001 }}
    >
      <input
        className="form-check-input m-0 p-0 mt-1"
        style={{ width: '13px', height: '13px' }}
        checked={isVisible}
        type="checkbox"
        onClick={(): void => onCheckChanged(column, !isVisible)}
      />
      <label className="form-check-label flex-grow-1 small-text d-flex justify-content-between ml-4">
        {tableSchema[column].readableName}
        <DragHandle />
      </label>
    </li>
  ),
);

const DropdownSortableContainer = SortableContainer(({ children }: { children: JSX.Element }) => (
  <ul className="list-group" style={{ minWidth: '16rem' }}>
    {children}
  </ul>
));

interface ColumnDropDownProps {
  tableSchema: TableSchema;
  allOrderedColumns: string[];
  visibleColumns: string[];
  setColumnsOrder(columns: string[]): void;
  setVisibleColumns(columns: string[]): void;
}

const ColumnDropDown = ({
  tableSchema,
  allOrderedColumns,
  visibleColumns,
  setColumnsOrder,
  setVisibleColumns,
}: ColumnDropDownProps): JSX.Element => {
  const onSortEnd = ({ oldIndex, newIndex }: SortEnd): void => {
    let newOrderedColumns = allOrderedColumns.slice();
    newOrderedColumns = arrayMove(newOrderedColumns, oldIndex, newIndex);
    setColumnsOrder(newOrderedColumns);
  };

  const onCheckChanged = (item: string, isChecked: boolean): void => {
    const newVisibleColumns = visibleColumns.slice();

    if (isChecked) {
      newVisibleColumns.push(item);
    } else {
      newVisibleColumns.splice(newVisibleColumns.indexOf(item), 1);
    }

    setVisibleColumns(newVisibleColumns);
  };

  return (
    <DropdownSortableContainer
      onSortEnd={onSortEnd}
      useDragHandle
      helperClass="position-absolute draggable shadow-sm"
    >
      <>
        {allOrderedColumns.map((column, index) => (
          <SortableItem
            key={`column-${column}`}
            tableSchema={tableSchema}
            index={index}
            column={column}
            isVisible={visibleColumns.includes(column)}
            onCheckChanged={onCheckChanged}
          />
        ))}
      </>
    </DropdownSortableContainer>
  );
};
export default ColumnDropDown;
